module.exports = __webpack_public_path__ + "static/background-296d2b671ed8c6dd04ade0884ac512f1.jpg";